module.exports = __webpack_public_path__ + "img/f5.2eb1ea46.jpg";